window.loginRecaptchaSuccess = (token) => {
  document.getElementById('login-form').submit();
};

export function init() {
}

export function destroy() {
}
